module.exports = "https://cdn.realtymogul.com/static/media/icon_bed.bac35a5d.svg";